import React from 'react';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import FontStyles from 'constants/font-styles';
import { applyStyles, convertFullWidthKana } from 'util/helpers';
import i18n from 'i18n';
import TextField from 'components/common/TextField';
import {
  required,
  payerNamePattern,
  composeValidators
} from 'validation/validators';

const handleBlurKana = (change, value) => {
  const replaced = convertFullWidthKana(value);

  change('payment.payerName', replaced);
};

const Bank = ({ className, change }) => (
  <div className={className}>
    <div className="description">
      <div className="description-label">
        {i18n.t('orderAggregators:payment:payment.bank.transferFee')}
      </div>
      <p>{i18n.t('orderAggregators:payment:payment.bank.transferFeeNote')}</p>
    </div>

    <TextField
      name="payment.payerName"
      label={i18n.t('orderAggregators:payment:payment.bank.payerName')}
      maxLength={30}
      placeholder={i18n.t(
        'orderAggregators:payment:payment.bank.payerNamePlaceholder'
      )}
      notes={[i18n.t('orderAggregators:payment:payment.bank.payerNameNote1')]}
      validate={value => composeValidators(required, payerNamePattern)(value)}
      onBlur={value => handleBlurKana(change, value)}
      required={true}
    />
    <ul className="description">
      <li className="description-note">
        {i18n.t('orderAggregators:payment:payment.bank.payerNameNote2')}
      </li>
    </ul>

    <div className="description">
      <div className="description-label">
        {i18n.t('orderAggregators:payment:payment.bank.transferAccount')}
      </div>
      <p className="transfer-account-note">
        {i18n.t('orderAggregators:payment:payment.bank.transferAccountNote')}
      </p>
    </div>

    <div className="description">
      <div className="description-label">
        {i18n.t('orderAggregators:payment:payment.bank.transferDate')}
      </div>
      <p>{i18n.t('orderAggregators:payment:payment.bank.transferDateNote1')}</p>
      <div className="description-note">
        {i18n.t('orderAggregators:payment:payment.bank.transferDateNote2')}
      </div>
    </div>
  </div>
);

const commonStyle = css`
  .description {
    ${FontStyles.text8};
    list-style: none;

    p {
      margin: 0;
    }
  }

  .description-label {
    ${FontStyles.text5};

    margin-top: 40px;
    margin-bottom: 16px;
  }

  ${TextField} {
    margin-bottom: 0px;
  }

  .description-note {
    ${FontStyles.text7}
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  .description {
    padding-left: 0;

  .transfer-account-note {
      max-width: 620px;
    }
  }
  .description-note {
    margin-top: 16px;
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  .description {
    padding: 0 16px;
  }

  .description-note {
    margin-top: 8px;
    text-indent: -1.25em;
    padding-left: 1.25em;
  }

`;

export default applyStyles(Bank)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/OrderAggregators/Payment/components/Bank.js